import * as Icons from '@ant-design/icons';
import dayjs from 'dayjs';
import {
  Button,
  DatePicker,
  Flex,
  Form,
  Input,
  InputNumber,
  Skeleton,
  Tabs,
  Typography
} from 'antd';
import { FieldsetTitle } from 'components/professor_area/FieldsetTitle';
import { FormItemCol } from 'components/professor_area/FormItemCol';
import { TabAcademicHistory } from 'pages/academic/users/graduate_enrollment/components/TabAcademicHistory';
import { TabCurriculumGrid } from 'pages/academic/users/graduate_enrollment/components/TabCurriculumGrid';
import { useCertificateStore } from '../../certificate.store';
import { useNavigation } from '@refinedev/core';

const { Text } = Typography;

export const TabCourseInfo = () => {
  const { enrollment, certificate } = useCertificateStore();
  const date = dayjs(enrollment?.created_at);
  const { showUrl } = useNavigation();

  if (!enrollment) {
    return <Skeleton active />;
  }

  return (
    <Form initialValues={enrollment}>
      <fieldset className="mb-6">
        <FieldsetTitle title="Informações do curso" icon={Icons.ReadOutlined} />

        <div className="ml-7">
          <FormItemCol label="Curso" name={['course', 'name']}>
            <Input disabled />
          </FormItemCol>
          <FormItemCol label="Duração" name={['course', 'duration_in_hours']}>
            <InputNumber disabled addonAfter="horas" className="w-[150px]" />
          </FormItemCol>
          <FormItemCol
            label="Formação básica"
            name="formacao_basica"
            initialValue="Especialização"
          >
            <Input disabled />
          </FormItemCol>
          <FormItemCol
            label="Área de conhecimento"
            name="area_conhecimento"
            initialValue="NEGÓCIOS, ADMINISTRAÇÃO E DIREITO"
          >
            <Input disabled />
          </FormItemCol>
          <FormItemCol label="Data de matrícula">
            <DatePicker disabled format="DD/MM/YYYY" value={date} />
          </FormItemCol>
          <FormItemCol label="Código do matrícula" name="registration">
            <Input disabled />
          </FormItemCol>
          <FormItemCol label="Carga horária" name="duration_in_hours">
            <InputNumber disabled addonAfter="horas" className="w-[150px]" />
          </FormItemCol>
          <FormItemCol label="ID (Chave do curso)" name={['course', 'id']}>
            <Input disabled />
          </FormItemCol>
          <FormItemCol
            label="Referência externa"
            name={['course', 'exeternal_reference']}
          >
            <Input disabled />
          </FormItemCol>
        </div>
      </fieldset>

      <fieldset className="mb-6">
        <Flex justify="space-between" align="center" className="mb-6">
          <FieldsetTitle
            title="Dados Institucionais"
            icon={Icons.BankOutlined}
            className="mb-0"
          />
        </Flex>
        <div className="ml-7">
          <FormItemCol label="Código do EMEC" name={['course', 'emec']}>
            <Input disabled />
          </FormItemCol>
          <FormItemCol label="Código IES">
            <Input
              disabled
              value={
                certificate?.signature_partner?.certifier?.code ??
                'Gerado após a emissão'
              }
            />
          </FormItemCol>
        </div>
      </fieldset>

      <fieldset className="mb-8">
        <Flex justify="space-between" align="center" className="mb-6">
          <FieldsetTitle
            title="Histórico e Disciplinas"
            icon={Icons.HistoryOutlined}
            className="mb-0"
            hint={
              <Text type="secondary" className="font-normal">
                Informações sobre o grade curricular, notas e frequência das
                disciplinas cursadas
              </Text>
            }
          />
          <Button
            variant="outlined"
            iconPosition="end"
            icon={<Icons.ExportOutlined />}
            onClick={() => {
              window.open(showUrl('graduate_enrollment', enrollment?.id));
            }}
          >
            Mais informações
          </Button>
        </Flex>

        <Tabs type="line" defaultActiveKey="academic_history">
          <Tabs.TabPane tab="Grade curricular" key="academic_history">
            <TabCurriculumGrid
              courseId={enrollment.course.id}
              enrollmentId={enrollment.id}
              isUndergraduate={enrollment.course.kind === 'undergraduate'}
            />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Informações do Histórico" key="history_info">
            <TabAcademicHistory
              courseId={enrollment.course.id}
              enrollmentId={enrollment.id}
              isUndergraduate={enrollment.course.kind === 'undergraduate'}
            />
          </Tabs.TabPane>
        </Tabs>
      </fieldset>

      <fieldset>
        <FieldsetTitle
          title="Trabalho de conclusão de curso (TCC)"
          icon={Icons.UserOutlined}
          className="mb-6"
        />
        <div className="ml-7">
          <FormItemCol label="Tema do TCC" name="observation">
            <Input disabled />
          </FormItemCol>
        </div>
      </fieldset>
    </Form>
  );
};
